export default function programCourseList(curriculum) {
    return {
    preRequisiteCoursesList: [],
    requiredCoursesList: [],
    electiveCoursesList: [],
    nonTradCode:'',
    errorMessage: "",
     courseDeailsUrl:"",
    
      getDetailsUrl(item) {
          var tbsCount = 0;
          for (let k = 0; k < item.scheduleList.length; k++) {

              if (item.scheduleList[k].classTypeText === 'TBS') {
                  tbsCount += 1;
              }
          }
          if (tbsCount === item.scheduleList.length) {

              if (this.nonTradCode != null && this.nonTradCode != "") {
                  return (
                      this.courseDeailsUrl +
                      "?eventId=" +
                      encodeURIComponent(item.eventId) +
                      "&format=" +
                      encodeURIComponent("TBS")+"&nonTradCode=" +
                      encodeURIComponent(this.nonTradCode)
                  );
              } else {
                  return (
                      this.courseDeailsUrl +
                      "?eventId=" +
                      encodeURIComponent(item.eventId) +
                      "&format=" +
                      encodeURIComponent("TBS")
                  );
              }
             
          }
          else {
              if (this.nonTradCode != null && this.nonTradCode != "") {
                  return (
                      this.courseDeailsUrl +
                      "?eventId=" +
                      encodeURIComponent(item.eventId) + "&nonTradCode=" +
                      encodeURIComponent(this.nonTradCode)
                  );
              } else {
                  return (
                      this.courseDeailsUrl +
                      "?eventId=" +
                      encodeURIComponent(item.eventId)
                  );
              }
            
          }
         
      },
      checkNullSerialId(item) {
               
              if (item.eventId != null) {
                  return true;

              }
         
          else {
              return false;
          }
      },

      checkNullSerialIdCourseList(item) {
         
          var presentCount = 0;
          for (let k = 0; k < item.length; k++) {
              
              if (item[k].eventId !== null) {
                  presentCount += 1;
              }
          }

          if (presentCount > 0) {
              return true;
          }
          else {
              return false;
          }
      },
      formatEventId(eventId) {
          if (eventId != null) {
              return eventId.replace("_", " ");
          }
      },
      get preRequisiteCoursesUnits() {
          var preRequisiteCoursesCredits = 0;
          for (let k = 0; k < this.preRequisiteCoursesList.length; k++) {
              var presentCount = 0;
             
                  if (this.preRequisiteCoursesList[k].eventId !== null) {
                      presentCount += 1;
                  }
              
              if (presentCount > 0) {
                  preRequisiteCoursesCredits += this.preRequisiteCoursesList[k].credits;
              }
          }
        
         return preRequisiteCoursesCredits;
         
    },
      get requiredCoursesUnits() {
          var requiredCoursesCredits = 0;
          for (let k = 0; k < this.requiredCoursesList.length; k++) {
              var presentCount = 0;
              
                  if (this.requiredCoursesList[k].eventId !== null) {
                      presentCount += 1;
                  }
              
              if (presentCount > 0) {
                  requiredCoursesCredits += this.requiredCoursesList[k].credits;
              }
          }

          return requiredCoursesCredits;
     
    },
      get electiveCoursesUnits() {
          var electiveCoursesCredits = 0;
          for (let k = 0; k < this.electiveCoursesList.length; k++) {
              var presentCount = 0;
              
                  if (this.electiveCoursesList[k].eventId !== null) {
                      presentCount +=1;
                  }
              
              if (presentCount > 0) {
                  electiveCoursesCredits += this.electiveCoursesList[k].credits;
              }
          }

          return electiveCoursesCredits;
 
    },

        async getProgramCoursesList(curriculum) {
            
          var nonTradCode = document.getElementById("nonTradCode").value;
          nonTradCode = nonTradCode == "" ? "" : nonTradCode;
          var notifyMe = false;
          
          for (let i = 1; i < 4; i++) {
              var jsonData = JSON.stringify({
                  "Curriculum": curriculum,
                  "RequirementType": i,
                  "NotifyMe": notifyMe,
                  "NonTradCode": nonTradCode

              });
              fetch("/api/ProgramAPI/GetCoursesList", {
                  method: "POST",
                  headers: {
                      Accept: "application/json",
                      "Content-Type": "application/json",
                  },
                  body: jsonData,
              })                  
          .then((response) => {
            if (response.ok) {
              return response.json();
            }
          })
          .then((response) => {
            if (response.isSuccess) {
             
              if (i === 1) {
                  this.preRequisiteCoursesList = response.courses;
              } else if (i === 2) {
                  this.requiredCoursesList = response.courses;
              } else if (i === 3) {
                  this.electiveCoursesList = response.courses;
              }
            } else {
              this.errorMessage = response.message;
            }
          });
      }
    },

        init() {
          
          
            this.getProgramCoursesList(curriculum);
        this.nonTradCode = document.getElementById("nonTradCode") != null
            ? document.getElementById("nonTradCode").value
            : "";
        this.courseDeailsUrl = document.getElementById("courseDeailsUrl").value;
    },
  };
}
